<!--  -->
<template>
  <div class="frame">
    <!-- 大图预览dialog -->
    <div class="dialog" v-show="previewShow">
      <div class="mask" @click="closePreView"></div>
      <img
        src="../assets/manager/close.png"
        class="close"
        @click="closePreView"
      />
      <img src="../assets/manager/left.png" class="left" @click="previewPre" />
      <img
        src="../assets/manager/right.png"
        class="right"
        @click="previewNext"
      />
      <div class="indicator">
        <span class="indicator_idx">{{ nowRowIdx }}</span> /
        <span class="indicator_all">{{ allLen }}</span>
      </div>
      <img id="preview" :src="previewUrl" alt="" />
    </div>
    <div class="manager_header">
      <titleBox
        :title="$t('message.manager.title')"
        :desc="$t('message.manager.subTitle')"
      ></titleBox>
    </div>
    <div class="content">
      <div class="type_list">
        <div
          :class="{ type: true, active: activeItem == 0 }"
          @click="changeItem(0)"
        >
          {{ $t("message.manager.type1.title") }}
        </div>
        <div
          :class="{ type: true, active: activeItem == 1 }"
          @click="changeItem(1)"
        >
          {{ $t("message.manager.type2.title") }}
        </div>
        <div
          :class="{ type: true, active: activeItem == 2 }"
          @click="changeItem(2)"
        >
          {{ $t("message.manager.type2b.title") }}
        </div>
        <div
          :class="{ type: true, active: activeItem == 3 }"
          @click="changeItem(3)"
        >
          {{ $t("message.manager.type3.title") }}
        </div>
      </div>
      <div class="show_list">
        <div
          class="show_panels"
          ref="showPanels"
          :style="panelMinHeight ? { minHeight: panelMinHeight + 'px' } : null"
        >
          <div class="show" v-show="activeItem === 0">
            <div class="top">
              <img class="show_bg" src="@/assets/manager/manager1.jpg" alt="" />
              <div class="info">
                <div class="title">
                  {{ $t("message.manager.type1.subTitle") }}
                </div>
                <div class="desc">{{ $t("message.manager.type1.desc") }}</div>
                <div class="box">
                  <div class="box1">
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_house.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type1.room") }}</p>
                        </div>
                      </div>
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_location.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type1.addrTitle") }}：</p>
                          <p>{{ $t("message.manager.type1.addr.addr1") }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_traffic.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>
                            {{ $t("message.manager.type1.trafficTitle") }}：
                          </p>
                          <p>
                            {{ $t("message.manager.type1.traffic.traffic1") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type1.traffic.traffic2") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type1.traffic.traffic3") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type1.traffic.traffic4") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type1.traffic.traffic5") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type1.traffic.traffic6") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box2">
                    <div class="item">
                      <img class="icon" src="@/assets/icon_car.png" alt="" />
                      <div class="item_desc btns">
                        <a
                          target="_blank"
                          :href="$t('message.manager.type1.linkList[0].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type1.linkList[0].name") }}
                          </div>
                        </a>
                        <a
                          target="_blank"
                          :href="$t('message.manager.type1.linkList[1].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type1.linkList[1].name") }}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="show" v-show="activeItem === 1">
            <div class="top">
              <img class="show_bg" src="@/assets/manager/manager2_red.jpg" alt="" />
              <div class="info">
                <div class="title">
                  {{ $t("message.manager.type2.subTitle") }}
                </div>
                <div class="desc">
                  {{ $t("message.manager.type2.desc") }}
                </div>
                <div class="box">
                  <div class="box1">
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_house.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type2.room") }}</p>
                        </div>
                      </div>
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_location.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type2.addrTitle") }}：</p>
                          <p>{{ $t("message.manager.type2.addr.addr1") }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_traffic.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>
                            {{ $t("message.manager.type1.trafficTitle") }}：
                          </p>
                          <p>
                            {{ $t("message.manager.type2.traffic.traffic1") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2.traffic.traffic2") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2.traffic.traffic3") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2.traffic.traffic4") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2.traffic.traffic5") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box2">
                    <div class="item">
                      <img class="icon" src="@/assets/icon_car.png" alt="" />
                      <div class="item_desc btns">
                        <a
                          target="_blank"
                          :href="$t('message.manager.type2.linkList[0].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type2.linkList[0].name") }}
                          </div>
                        </a>
                        <a
                          target="_blank"
                          :href="$t('message.manager.type2.linkList[1].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type2.linkList[1].name") }}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="show" v-show="activeItem === 2">
            <div class="top">
              <img
                class="show_bg"
                src="@/assets/manager/manager2_blue.jpg"
                alt=""
              />
              <div class="info">
                <div class="title">
                  {{ $t("message.manager.type2b.subTitle") }}
                </div>
                <div class="desc">
                  {{ $t("message.manager.type2b.desc") }}
                </div>
                <div class="box">
                  <div class="box1">
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_house.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type2b.room") }}</p>
                        </div>
                      </div>
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_location.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type2b.addrTitle") }}：</p>
                          <p>{{ $t("message.manager.type2b.addr.addr1") }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_traffic.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>
                            {{ $t("message.manager.type1.trafficTitle") }}：
                          </p>
                          <p>
                            {{ $t("message.manager.type2b.traffic.traffic1") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2b.traffic.traffic2") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2b.traffic.traffic3") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2b.traffic.traffic4") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type2b.traffic.traffic5") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box2">
                    <div class="item">
                      <img class="icon" src="@/assets/icon_car.png" alt="" />
                      <div class="item_desc btns">
                        <a
                          target="_blank"
                          :href="$t('message.manager.type2b.linkList[0].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type2b.linkList[0].name") }}
                          </div>
                        </a>
                        <a
                          target="_blank"
                          :href="$t('message.manager.type2b.linkList[1].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type2b.linkList[1].name") }}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="show" v-show="activeItem === 3">
            <div class="top">
              <img class="show_bg" src="@/assets/manager/manager3.jpg" alt="" />
              <div class="info">
                <div class="title">
                  {{ $t("message.manager.type3.subTitle") }}
                </div>
                <div class="desc">
                  {{ $t("message.manager.type3.desc1") }}<br />
                  {{ $t("message.manager.type3.desc2") }}
                </div>
                <div class="box">
                  <div class="box1">
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_house.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type3.room") }}</p>
                        </div>
                      </div>
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_location.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>{{ $t("message.manager.type3.addrTitle") }}：</p>
                          <p>{{ $t("message.manager.type3.addr.addr1") }}</p>
              
                        </div>
                      </div>
                    </div>
                    <div class="about_item">
                      <div class="item">
                        <img
                          class="icon"
                          src="@/assets/icon_traffic.png"
                          alt=""
                        />
                        <div class="item_desc">
                          <p>
                            {{ $t("message.manager.type1.trafficTitle") }}：
                          </p>
                          <p>
                            {{ $t("message.manager.type3.traffic.traffic1") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type3.traffic.traffic2") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type3.traffic.traffic3") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type3.traffic.traffic4") }}
                          </p>
                          <p>
                            {{ $t("message.manager.type3.traffic.traffic5") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box2">
                    <div class="item">
                      <img class="icon" src="@/assets/icon_car.png" alt="" />
                      <div class="item_desc btns">
                        <a
                          target="_blank"
                          :href="$t('message.manager.type3.linkList[0].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type3.linkList[0].name") }}
                          </div>
                        </a>
                        <a
                          target="_blank"
                          :href="$t('message.manager.type3.linkList[1].href')"
                        >
                          <div class="btn">
                            {{ $t("message.manager.type3.linkList[1].name") }}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="album_bottom">
          <button
            type="button"
            class="album_nav album_nav--prev"
            aria-label="上一组"
            @click="scrollAlbum(-1)"
          >
            ‹
          </button>
          <div
            class="album_viewport"
            ref="albumScroll"
            @click="preview($event)"
          >
            <ul class="album">
              <li
                v-for="photo in currentAlbumPhotos"
                :key="`${photo.col}-${photo.row}`"
                class="photo"
                :data="`${photo.col},${photo.row},${photo.max}`"
              >
                <img :src="photo.src" alt="" />
              </li>
            </ul>
          </div>
          <button
            type="button"
            class="album_nav album_nav--next"
            aria-label="下一组"
            @click="scrollAlbum(1)"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeItem: 0,
      albumConfig: [
        { col: 1, count: 14 },
        { col: 2, count: 10 },
        { col: 4, count: 7 },
        { col: 3, count: 10 },
      ],
      allLen: 0,
      nowColIdx: 1,
      nowRowIdx: 1,
      previewShow: false,
      previewUrl: "",
      panelMinHeight: 0,
    };
  },
  computed: {
    currentAlbumPhotos() {
      const config = this.albumConfig[this.activeItem];
      if (!config) {
        return [];
      }
      const photos = [];
      for (let i = 1; i <= config.count; i++) {
        photos.push({
          col: config.col,
          row: i,
          max: config.count,
          src: require(`../assets/manager/img${config.col}_${i}.jpeg`),
        });
      }
      return photos;
    },
  },
  created() {},
  mounted() {
    this.syncPanelHeight();
    window.addEventListener("resize", this.syncPanelHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncPanelHeight);
  },
  watch: {
    "$i18n.locale"() {
      this.syncPanelHeight();
    },
  },
  methods: {
    syncPanelHeight() {
      this.$nextTick(() => {
        const panels = this.$refs.showPanels
          ? this.$refs.showPanels.querySelectorAll(".show")
          : [];
        let max = 0;
        panels.forEach((panel) => {
          panel.classList.add("measure");
          max = Math.max(max, panel.offsetHeight);
          panel.classList.remove("measure");
        });
        if (max > 0) {
          this.panelMinHeight = max;
        }
      });
    },
    changeItem(val) {
      if (this.activeItem === val) {
        return;
      }
      this.activeItem = val;
      this.$nextTick(() => {
        const album = this.$refs.albumScroll;
        if (album) {
          album.scrollLeft = 0;
        }
      });
    },
    scrollAlbum(direction) {
      const el = this.$refs.albumScroll;
      if (!el) {
        return;
      }
      const photo = el.querySelector(".photo");
      const gap = 12;
      const step = photo ? photo.offsetWidth + gap : 180;
      el.scrollBy({ left: direction * step, behavior: "smooth" });
    },
    // 通过数据代理获取虚拟dom的data属性
    preview(e) {
      const path = e.path || (e.composedPath && e.composedPath());
      let target = path.filter((r) => /photo/.test(r.className));
      if (!target.length) {
        return;
      }
      target = target[0];
      const data = target.getAttribute("data"); // 数据
      const dataArr = data.split(","); // 转换为数组
      this.previewOne(dataArr[0], dataArr[1], dataArr[2]);
    },
    previewOne(colIdx, rowIdx, maxLen) {
      this.allLen = maxLen;
      this.nowColIdx = colIdx;
      this.nowRowIdx = rowIdx;
      this.previewUrl = require(`../assets/manager/img${colIdx}_${rowIdx}.jpeg`);
      this.previewShow = true;
    },
    previewPre() {
      if (this.nowRowIdx == 1) {
        this.nowRowIdx = this.allLen;
      } else {
        this.nowRowIdx--;
      }
      this.previewUrl = require(`../assets/manager/img${this.nowColIdx}_${this.nowRowIdx}.jpeg`);
    },
    previewNext() {
      if (this.nowRowIdx == this.allLen) {
        this.nowRowIdx = 1;
      } else {
        this.nowRowIdx++;
      }
      this.previewUrl = require(`../assets/manager/img${this.nowColIdx}_${this.nowRowIdx}.jpeg`);
    },
    closePreView() {
      this.previewShow = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.manager_header {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/manager_bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  ::v-deep .title_box {
    background-color: transparent;
    height: auto;
    padding: 0 16px;
    box-sizing: border-box;

    .title {
      color: $text-dark;
      font-size: 32px;
      text-shadow: none;
    }

    .desc {
      color: #666;
      text-shadow: none;
    }
  }
}

.content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 60px;
  background-color: transparent;
  padding: 0 16px;
  box-sizing: border-box;

  .type_list {
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    color: #666;
    gap: 0;

    .type {
      flex: 1 1 0;
      min-width: 140px;
      max-width: 240px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border: none;
      border-left: 0;
      cursor: pointer;
      position: relative;
      transition: all 0.3s;
      background-color: #f0f0f0;
      color: #666;
      font-size: 14px;

      &:first-child {
        border-left: none;
      }
      &::after {
        content: "";
        border-width: 6px;
        border-color: $theme transparent transparent transparent;
        border-style: solid;
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translateX(-50%);
        opacity: 0;
      }

      &:hover {
        background-color: #e8e8e8;
        color: $text-dark;
      }
    }
    .active {
      color: #fff;
      background-color: $theme;

      &::after {
        opacity: 1;
      }
    }
  }
  .show_list {
    margin-top: 32px;
    overflow: hidden;
    position: relative;
    width: 100%;
    background: #fff;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    border-radius: 2px;

    .show_panels {
      position: relative;

      .show.measure {
        display: block !important;
        visibility: hidden;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        pointer-events: none;
      }
    }

    .show {
      width: 100%;
      padding: 28px 24px 0;
      box-sizing: border-box;

      .top {
        display: flex;
        justify-content: space-between;
        gap: 20px;

        .show_bg {
          width: 413px;
          max-width: 100%;
          height: 500px;
          object-fit: cover;
        }

        .info {
          flex: 1;
          min-width: 0;

          .title {
            font-size: 20px;
          }
          .desc {
            height: 150px;
            margin: 20px 0;
            font-size: 14px;
            color: #666;
            line-height: 28px;
          }

          .box {
            .item {
              width: 100%;
              display: flex;
              align-items: flex-start;
              margin-bottom: 10px;

              .icon {
                width: 20px;
                margin-top: 5px;
              }

              .item_desc {
                margin-left: 10px;
                font-size: 14px;
                color: #666;
                line-height: 28px;

                a {
                  text-decoration: none;
                  margin-right: 10px;
                }
                .btn {
                  width: 130px;
                  height: 40px;
                  border: 1px solid $theme;
                  color: $theme;
                  background-color: #fff;
                  transition: all 0.3s;
                  text-align: center;
                  line-height: 38px;
                  font-size: 13px;

                  &:hover {
                    cursor: pointer;
                    background-color: $theme;
                    color: #fff;
                  }
                }
              }
              .btns {
                display: flex;
              }
            }
            .box1 {
              display: flex;

              .about_item {
                width: 50%;

                & + .about_item {
                  margin-left: 30px;
                }
              }
            }
          }
        }
      }
    }

    .album_bottom {
      display: flex;
      align-items: center;
      width: 100%;
      margin-top: 24px;
      padding: 0 20px 36px;
      box-sizing: border-box;

      .album_nav {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        padding: 0;
        border: none;
        background: transparent;
        color: #666;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;

        &:hover {
          color: $theme;
        }
      }

      .album_viewport {
        flex: 1;
        min-width: 0;
        margin: 0 12px;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .album {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          gap: 12px;
          width: max-content;

          .photo {
            flex: 0 0 175px;
            width: 175px;
            height: 130px;
            cursor: pointer;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
}

.dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}
.dialog .mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
}
.dialog .close {
  width: 40px;
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}
.dialog .left,
.dialog .right {
  width: 40px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.dialog .left {
  left: 20px;
}
.dialog .right {
  right: 20px;
}
.dialog #preview {
  max-width: 80%;
  max-height: 90%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

@include respond-md {
  .manager_header {
    min-height: 260px;

    ::v-deep .title_box {
      .title {
        font-size: 26px;
      }
    }
  }

  .content {
    margin-top: 24px;
    margin-bottom: 40px;

    .type_list {
      .type {
        flex: 1 1 calc(50% - 8px);
        max-width: none;
        font-size: 13px;
        height: 44px;
        line-height: 44px;
      }
    }

    .show_list {
      margin-top: 24px;

      .show {
        .top {
          flex-direction: column;

          .show_bg {
            width: 100%;
            height: auto;
            max-height: 320px;
          }

          .info {
            width: 100%;

            .desc {
              height: auto;
              min-height: auto;
            }

            .box {
              .box1 {
                flex-direction: column;

                .about_item {
                  width: 100%;

                  & + .about_item {
                    margin-left: 0;
                    margin-top: 10px;
                  }
                }
              }

              .btns {
                flex-wrap: wrap;
                gap: 10px;
              }
            }
          }
        }
      }

      .album_bottom {
        padding: 0 12px 28px;

        .album_nav {
          width: 20px;
          height: 20px;
          font-size: 20px;
        }

        .album_viewport {
          margin: 0 8px;

          .album .photo {
            flex: 0 0 140px;
            width: 140px;
            height: 105px;
          }
        }
      }
    }
  }

  .dialog {
    .left,
    .right {
      width: 32px;
    }

    .left {
      left: 8px;
    }

    .right {
      right: 8px;
    }

    .close {
      width: 32px;
      right: 12px;
      top: 12px;
    }

    #preview {
      max-width: 92%;
    }
  }
}

@include respond-sm {
  .content {
    .type_list {
      .type {
        flex: 1 1 100%;
      }
    }
  }
}
.indicator {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
}
.indicator_idx {
  font-size: 18px;
}
</style>